import React from 'react';
import { Alert } from 'reactstrap';

interface ErrorAlertProps {
  error: string | null;
  onDismiss?: () => void;
}

export const ErrorAlert: React.FC<ErrorAlertProps> = ({ error, onDismiss }) => {
  if (!error) return null;

  return (
    <Alert color="danger" toggle={onDismiss} className="mb-3">
      <strong>Error:</strong> {error}
    </Alert>
  );
};

